import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 112,
	height: 112,
	viewBox: "0 0 112 112",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M56 105C28.938 105 7 83.062 7 56C7 28.938 28.938 7 56 7C83.062 7 105 28.938 105 56C105 83.062 83.062 105 56 105ZM56 28C53.1005 28 50.75 30.3505 50.75 33.25V54.25C50.75 57.1495 53.1005 59.5 56 59.5C58.8995 59.5 61.25 57.1495 61.25 54.25V33.25C61.25 30.3505 58.8995 28 56 28ZM56 84C52.134 84 49 80.866 49 77C49 73.134 52.134 70 56 70C59.866 70 63 73.134 63 77C63 80.866 59.866 84 56 84Z",
		fill: "#09090B"
	})
});
export default SvgExclamationCircle;
